/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApReportCard = /** @class */ (function () {
            function ApReportCard($scope, applicationService, metaService, modalService, locationService, appSettings, $location, $cookies) {
                this.$scope = $scope;
                this.applicationService = applicationService;
                this.metaService = metaService;
                this.modalService = modalService;
                this.locationService = locationService;
                this.appSettings = appSettings;
                this.$location = $location;
                this.$cookies = $cookies;
                this.mediaApiUrl = this.appSettings.urls.mediaApiUrl;
                this.isRedcap = false;
                this.reportId = this.$location.search().reportId || null;
                this.authDataCookieName = 'authorizationData';
                this.activeReport = this.$scope.report;
                this.isRedcap = this.$location.search().thirdparty === ThirdParty.RedCap;
                if (this.isRedcap && (ap.Constants.redcapReportTitles.includes(this.activeReport.ssrsName)))
                    this.redirectForThirdParty();
            }
            ApReportCard.prototype.openReportConfig = function (event) {
                var _this = this;
                event.preventDefault();
                var reportOptions = {
                    headerText: 'Filter Report',
                    bodyText: '',
                    actionButtonText: 'Run',
                    closeButtonText: 'Cancel',
                    activeReport: this.activeReport
                };
                var updateAndRun = function (result) {
                    if (result.action === ModalActionResult.Saved) {
                        _this.applicationService.getActiveReport().then(function (newActiveReport) {
                            _this.activeReport = newActiveReport;
                            var cacheKey = _this.applicationService.getDefaultOrg();
                            _this.locationService.redirect(ap.Constants.routes.reportDisplay, _this.activeReport.ssrsName.toLowerCase(), cacheKey);
                        });
                    }
                };
                if (!ap.Utilities.isNullOrUndefined(this.activeReport.isWpReport) && this.activeReport.isWpReport) {
                    this.modalService.openEditReportConfigModal(reportOptions).then(function (result) {
                        updateAndRun(result);
                    });
                }
                else {
                    this.applicationService
                        .setActiveReport(this.activeReport)
                        .then(function (updatedActiveReport) {
                        reportOptions.activeReport = updatedActiveReport;
                        _this.modalService.openMultipointReportConfigModal(reportOptions).then(function (result) {
                            updateAndRun(result);
                        });
                    });
                }
            };
            ApReportCard.prototype.runReport = function (event, paramsUpdated) {
                var _this = this;
                this.applicationService.setActiveReport(this.activeReport).then(function (updatedActiveReport) {
                    _this.activeReport = updatedActiveReport;
                    if (!event.isDefaultPrevented() || paramsUpdated) {
                        if (!paramsUpdated) {
                            _this.applicationService.resetReportParams();
                        }
                        var cacheKey = _this.applicationService.getDefaultOrg();
                        _this.locationService.redirect(ap.Constants.routes.reportDisplay, _this.activeReport.ssrsName.toLowerCase(), cacheKey);
                    }
                });
            };
            ApReportCard.prototype.redirectForThirdParty = function () {
                switch (parseInt(this.reportId, 10)) {
                    case (ReportTitles.ProcessMetrics):
                        if (this.activeReport.ssrsName.toLowerCase() === 'process-metrics') {
                            this.updateActiveReportAndRedirect();
                        }
                        break;
                    case (ReportTitles.SalesPerformance):
                        if (this.activeReport.ssrsName.toLowerCase() === 'sales-performance') {
                            this.updateActiveReportAndRedirect();
                        }
                        break;
                    case (ReportTitles.PerformanceAverages):
                        if (this.activeReport.ssrsName.toLowerCase() === 'performance-averages') {
                            this.updateActiveReportAndRedirect();
                        }
                        break;
                    case (ReportTitles.ShopBenchmarks):
                        if (this.activeReport.ssrsName.toLowerCase() === 'shop-benchmarks') {
                            this.updateActiveReportAndRedirect();
                        }
                        break;
                    default:
                        var logoutURL = this.appSettings.urls.sso + "/#/failedlogin?redirect=" + encodeURIComponent(window.location.href) + "&clientId=" + this.appSettings.applicationCacheKey;
                        this.$cookies.remove(this.authDataCookieName);
                        window.location.href = logoutURL;
                        break;
                }
            };
            ApReportCard.prototype.updateActiveReportAndRedirect = function () {
                var _this = this;
                this.applicationService.setActiveReport(this.activeReport).then(function (updatedActiveReport) {
                    _this.activeReport = updatedActiveReport;
                    var cacheKey = _this.applicationService.getDefaultOrg();
                    _this.locationService.redirect(ap.Constants.routes.reportDisplay, _this.activeReport.ssrsName.toLowerCase(), cacheKey);
                });
            };
            ApReportCard.$inject = [
                '$scope',
                'applicationService',
                'metaService',
                'modalService',
                'locationService',
                'appSettings',
                '$location',
                '$cookies'
            ];
            return ApReportCard;
        }());
        Directives.ApReportCard = ApReportCard;
        angular.module('app.Directives').controller('ApReportCard', ApReportCard);
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
